import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { InspectionAppliancesInformation } from '../../models/inspectionEvaluationIssue';

type ApplianceDetailProps = {
  appliance: InspectionAppliancesInformation;
};

const InspectionEvaluationApplianceDisplay: React.FC<ApplianceDetailProps> = ({ appliance }) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Typography sx={styles.applianceName}>{appliance.applianceName}</Typography>
        <Chip
          label={appliance.replace === 'Yes' ? 'Replacement Needed' : 'No Replacement'}
          color={appliance.replace === 'Yes' ? 'error' : 'success'}
          icon={appliance.replace === 'Yes' ? <HighlightOffIcon /> : <CheckCircleIcon />}
          sx={{ marginLeft: 1 }}
        />
      </Box>

      <Typography sx={styles.location}>
        <strong>Location:</strong> {appliance.location}
      </Typography>
{/*       <Typography sx={styles.details}>
        <strong>Details:</strong> {appliance.details}
      </Typography> */}
      {appliance.age !== undefined && (
        <Typography sx={styles.age}>
          <strong>Age:</strong> {appliance.age ? `${appliance.age} years` : 'Unknown'}
        </Typography>
      )}

      {/*( appliance.lowCost > 0 || appliance.highCost > 0) && (
        <Typography sx={styles.cost}>
          <strong>Estimated Cost:</strong> 
          {appliance.lowCost > 0 ? ` $${appliance.lowCost}` : ''} 
          {appliance.lowCost > 0 && appliance.highCost > 0 ? ' - ' : ''}
          {appliance.highCost > 0 ? `$${appliance.highCost}` : ''}
        </Typography> 
      ) */}
    </Box>
  );
};

const styles = {
  container: {
    width: '100%',
    padding: '8px 0',
    fontFamily: 'Arial, sans-serif',
    color: '#333',
    marginBottom: 2,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '4px',
  },
  applianceName: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  location: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '4px',
  },
  details: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '4px',
  },
  age: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '4px',
  },
  cost: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#333',
    marginTop: '8px',
  },
};

export default InspectionEvaluationApplianceDisplay;
